import { createSelectorCreator, defaultMemoize } from 'reselect';
import { is, Map } from 'immutable';

const createImmutableSelector = createSelectorCreator(defaultMemoize, is);
let selector = {};

const getHomesArray = homes => {
    return homes.reduce((reduction, value, key) => [...reduction, { value: key, label: value.get('label') }], []);
};

function Selector(_environment) {
    this.environment = _environment;
}
/*** SELECTORS Functions ***/
Selector.prototype.getHomesArray = function(...args) {
    return createImmutableSelector([this.getHomes.bind(this)], getHomesArray)(...args);
};

/*** SELECTORS SIMPLES ***/
Selector.prototype.getHomes = function(state) {
    return state.environments[this.environment].data.Homes.get('list');
};
Selector.prototype.getProfile = function(state) {
    return state.data.user;
};

export default function(environment) {
    if (!selector[environment]) {
        selector[environment] = new Selector(environment);
    }
    return selector[environment];
}



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/PushNotification/selectors.js